// TariffGroup/TariffGroupDetailPage.tsx
import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import TariffCard from 'Tariff/TariffCard';
import pprint from '../../Utils/pprint';
import {useErrorProcessing} from 'Core/components/ErrorProvider';
import {axios, DOMAIN_URL} from 'Auth/axiosConfig';
import {FCSC, FR, FRCT} from 'WideLayout/Layouts';
import CircularProgress from 'Core/components/elements/CircularProgress';
import Head from 'Core/components/Head';
import {ITariffGroup} from "Types/psychology/tariff";

const TariffGroupDetailPage: React.FC = () => {
    const {id} = useParams<{ id: string }>();
    const [group, setGroup] = useState<ITariffGroup | null>(null);
    const {byResponse} = useErrorProcessing();

    useEffect(() => {
        const fetchGroupDetail = async () => {
            try {
                const response = await axios.get(`/api/v1/tariff-groups/${id}/`);
                pprint('Tariff Group Detail');
                pprint(response.data);
                setGroup(response.data);
            } catch (error) {
                byResponse(error);
            }
        };
        fetchGroupDetail();
    }, [id]);

    if (!group) return <CircularProgress size={'150px'}/>;

    return (
        <FCSC pt={2}>
            <Head
                title={`${group.name} | Лайф Хелп`}
                description={group.description || 'Группа тарифов от сервиса Лайф Хелп'}
                robots={'noindex, nofollow'}
                canonicalUrl={`${DOMAIN_URL}/tariff-groups/${group.id}`}
            />
            <FR component={'h3'}>{group.name}</FR>
            {group.description && <p>{group.description}</p>}
            <FRCT pos={'relative'} p={2} wrap g={2} scroll={'y-auto'}>
                {group.tariffs.map((tariff) => (
                    <TariffCard key={tariff.id} tariff={tariff}/>
                ))}
            </FRCT>
        </FCSC>
    );
};

export default TariffGroupDetailPage;
